module.exports = __webpack_public_path__ + "img/6f622fd6080f250be240430856ad4e32.png";